import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl } from '../../common/rcs_gaz_mc_core_FE';
import TeamLabel from '../shared/TeamLabel';
import Result from '../TimeResults/Result';
import { MatchRowWrapper } from './styles';
import ConfigManager from '../../common/configManager/configManager';
import Label from '../shared/Label';

const CalendarRow = ({
  matchRow, dictionary, competitionId, newspaper, isGazzanet,
}) => {
  const isHomeWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) > Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  const isAwayWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) < Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  //const isLive = () => matchRow.status === 'LIVE';

  const classLink = () => {
    const homeCode = matchRow.getIn(['homeTeam', 'teamCode']);
    const awayCode = matchRow.getIn(['awayTeam', 'teamCode']);
    let returnedClass = '';
    if (homeCode && awayCode && homeCode.length < 3 && awayCode.length < 3) {
      returnedClass = 'no-event';
    }
    if (homeCode && awayCode && Number(homeCode[homeCode.length - 1]) && Number(awayCode[awayCode.length - 1])) {
      returnedClass = 'no-event';
    }
    return returnedClass;
  };

  const formatDate = (datePassed) => {
    const dateJs = new Date(datePassed);
    const day = (`0${dateJs.getDate().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const month = (`0${Number(dateJs.getMonth().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })) + 1}`).slice(-2);
    const year = dateJs.getFullYear().toLocaleString().slice(3, 5);
    return `${day}/${month}/${year}`;
  };

  const formatHour = (datePassed) => {
    const dateJs = new Date(datePassed);
    const hours = (`0${dateJs.getHours()
      .toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const minutes = (`0${dateJs.getMinutes()
      .toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    return `${hours}:${minutes}`;
  };

  const imagesURL = ConfigManager.getFootballTeams('min');
  const awayResPen = matchRow.getIn(['awayTeam', 'starData']) &&
  matchRow.getIn(['awayTeam', 'starData', 'shootOuts']) && matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) ?
    matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
  const homeResPen = matchRow.getIn(['homeTeam', 'starData']) &&
  matchRow.getIn(['homeTeam', 'starData', 'shootOuts']) && matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) ?
    matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;

  return (
    <MatchRowWrapper
      disableLink={isGazzanet}
      className={classLink()}
      href={prettyMatchUrl(matchRow.getIn(['homeTeam', 'teamName']), matchRow.getIn(['awayTeam', 'teamName']), matchRow.get('matchId'), 1, competitionId, newspaper)}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <Col
          md={12}
          style={{
            paddingLeft: 0, paddingRight: 0, display: 'flex', justifyContent: 'center',
          }}
        >
          <Label
            label={formatDate(matchRow.get('date'))}
            size={0.75}
            isTitleNarrowMedium
          />
        </Col>
      </Row>
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          sm={4.9}
          md={5}
          style={{
            paddingLeft: 0, paddingRight: 0, display: 'flex', justifyContent: 'center',
          }}
        >
          <React.Fragment>
            <Col
              sm={4.5}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <TeamLabel
                color="black"
                image={`${imagesURL}${matchRow.getIn(['homeTeam', 'teamId'])}.png`}
                marginLeft={0.5}
                font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
                size={16}
              />
            </Col>
            <Col
              sm={7.5}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <Label
                label={matchRow.getIn(['homeTeam', 'teamName']) !== 'TBC' ? matchRow.getIn(['homeTeam', 'teamName']) : '- -'}
                color="black"
                font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
                size={0.9}
              />
            </Col>
          </React.Fragment>
        </Col>
        <Col lg={2} md={2} sm={2} xs={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
          {(matchRow.get('status') === 'LIVE' || matchRow.get('status') === 'FULL') ?
            <Result
              awayRes={matchRow.getIn(['awayTeam', 'score'])}
              homeRes={matchRow.getIn(['homeTeam', 'score'])}
              awayPenRes={awayResPen}
              homePenRes={homeResPen}
              status={matchRow.get('status')}
            />
            :
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Label
                label={formatHour(matchRow.get('date'))}
              />
            </div>
          }
        </Col>
        <Col
          md={5}
          sm={4.9}
          style={{
            paddingLeft: 0,
            paddingRight: 0,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <React.Fragment>
            <Col
              sm={4.5}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <TeamLabel
                color="black"
                image={`${imagesURL}${matchRow.getIn(['awayTeam', 'teamId'])}.png`}
                marginLeft={0.5}
                font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
                size={16}
              />
            </Col>
            <Col
              sm={7.5}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <Label
                label={matchRow.getIn(['awayTeam', 'teamName']) !== 'TBC' ? matchRow.getIn(['awayTeam', 'teamName']) : '- -'}
                color="black"
                font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
                size={0.9}
              />
            </Col>
          </React.Fragment>
        </Col>
      </Row>
      <Row style={{
        width: '100%',
        marginRight: '0',
        marginLeft: '0',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      >
        <Col
          md={12}
          style={{
            paddingLeft: 0,
            paddingRight: 0,
            display: 'flex',
            justifyContent: 'center',
            overflow: 'visible',
          }}
        >
          <Label
            label={`${dictionary.competitionTable.competitionName[competitionId] || 'Altre competizioni '}`}
            margin="0px 5px 0px 0px"
            size={0.8}
          />
        </Col>
      </Row>
    </MatchRowWrapper>
  );
};

CalendarRow.propTypes = {
  matchRow: PropTypes.any,
  dictionary: PropTypes.any,
  competitionId: PropTypes.any,
  newspaper: PropTypes.any,
  isGazzanet: PropTypes.bool,
};

export default CalendarRow;



// WEBPACK FOOTER //
// ./src/components/CalendarRow/index.js